import { CompetitionResult, Result } from '~/apis/ssf';

export function getRank(result: CompetitionResult | Result, index: number) {
  if (result.rank) return result.rank;

  if (result.total === 0) return '-';

  return index + 1;
}
